import pinia from '@/common/pinia'

// Bridges Rails styxie initializers to the router shell. The styxie payload
// hydrates Pinia before mount so the first paint needs no extra requests;
// the router then matches window.location and renders the page.
export function routerStyxie({ actions, hydrate }) {
  const boot = async(props) => {
    if (hydrate) hydrate(props, pinia)
    const { default: mountRouterApp } = await import('@/common/mountRouterApp')
    return mountRouterApp()
  }

  return Object.fromEntries(actions.map((action) => [action, boot]))
}
